module.exports = __webpack_public_path__ + "img/info.34d8eaae.png";